// extracted by mini-css-extract-plugin
export default {"item":"SugestedPatients_item__HNkLP","buttons":"SugestedPatients_buttons__tcpt+"};